import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import { Link, useParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button, Card, Container, Col, Row, Spinner} from 'react-bootstrap';
import { InputField } from '../../components/Common/FormikField/InputField';
import { password, repassword, GetSchema } from '../../js/Base/ValidationSchema';
import toastAlert from '../../js/Base/ToastAlert';
import Image from 'react-bootstrap/Image';
import { checkForgetPwdById, setForgetPwd } from '../../api/authApi';

export default function ReSetPwd() {
  const { resetId } = useParams();
  const [loading, setLoading] = useState(true);

  const initialValues = {
    password: "",
    repeatPassword: "",
  };
  const formSchema = GetSchema({
    password: password(),
    repeatPassword: repassword('password')
  });

  const toLogin = () => {
    setTimeout(() => {
      document.location.assign(document.location.origin + '/');
    }, 3000);
  }

  const checkOnUsingID = async () => {
    try {
      const data = await checkForgetPwdById(resetId);
      if (!data.success) {
        toastAlert.autoClose(true).showError('密碼修改申請已過期，請重新申請。');
        toLogin();
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('密碼修改申請已過期，請重新申請。');
      toLogin();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkOnUsingID();
  }, []);

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    try {
      const data = await setForgetPwd(resetId, values.password);
      if (data.success) {
        toastAlert.autoClose(true).showSuccess('密碼修改成功，請重新登入');
        toLogin();
      } else {
        toastAlert.autoClose(true).showError('錯誤，請確認後重試');
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('錯誤，請確認後重試');
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  const input_style = {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    paddingLeft: '0px',
    borderRadius: '0px',
    marginTop: '30px',
    fontWeight: 'bold',
    fontSize: '14px',
  };

  const removeMenuLogHandler = () => {
    // dispatch(loginMenuAction.removeAllMenu());
  };

  return (
    <div className="LoginManagement">
      <div
        className="banner-1 login-page"
        style={{
          backgroundImage: `url(/assets/images/bg_login@2x.png)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          color: '#ffffff',
          padding: '0px',
        }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "transparent",
            p: 2,
          }}
        >
          <Link
            to="/"
            className="logo ms-4"
            onClick={() => {
              removeMenuLogHandler();
            }}
          >
            <Image alt="Cloudgoda" src="/assets/images/logo_deep_login_pg@2x.png" rounded style={{ width: '150px', height: 'auto' }}/>
          </Link>
          {loading ? (
            <div className="d-flex justify-content-center my-3">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <Paper elevation={3} sx={{ width: "100%", maxWidth: 400, p: 3 }}>
              <p className="paper-title">重設密碼</p>
              <p className="paper-desc">請輸入新密碼</p>
              <div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={formSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <InputField
                      id="password"
                      type="password"
                      className="input-field"
                      inputName="password"
                      placeholder="新密碼"
                      style={input_style}
                      isInvalid={errors.password && touched.password}
                      />
                      <InputField
                      id="repeatPassword"
                      type="password"
                      className="input-field"
                      inputName="repeatPassword"
                      placeholder="再次輸入新密碼"
                      style={input_style}
                      isInvalid={errors.repeatPassword && touched.repeatPassword}
                      />

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn-login btn-custom"
                        style={{ height: "36px" }}
                      >
                        {isSubmitting? "請稍後..." : "重設密碼"}
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </Paper>
          )}
        </Box>
      </div>
    </div>
  )
}
